import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`;

type ContentProps = {
  withFloatingButton: boolean;
};

export const Content = styled.div<ContentProps>`
  flex: 1;
  /* padding bottom w/ floating button: FAB height + 2 rem spacing */
  padding: 32px 16px ${({ withFloatingButton }) => (withFloatingButton ? '88' : '24')}px 16px;
  background-color: ${({ theme }) => theme.basicLayout.backgroundColor};
`;

export const Title = styled.h3`
  font-size: 16px;
  font-weight: 600;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Subtitle = styled.small`
  font-size: 12px;
  line-height: 1.5;
  font-weight: normal;
  letter-spacing: normal;
  text-align: center;
  color: ${ColorPalette.HEX.DimGray};
`;
